import { IPaymentMethod } from "swiipe.portal.shared"

export interface IPaymentMethodRelation extends IPaymentMethod {
    isPrimary?: boolean
}

export const allPaymentMethodRelationTypes = ["Billing"] as const

export type TPaymentMethodRelation = (typeof allPaymentMethodRelationTypes)[number]
